import React, {Component} from 'react';
import ReactResizeDetector from 'react-resize-detector';
import PropTypes from 'prop-types';

class ScalePoints extends Component {

  constructor(props){
    super(props);

    this.state = {
      highestPointHeight: 0
    };

    this.setHighestPointHeight = this.setHighestPointHeight.bind(this);
    props.scalePoints.forEach((item) => {
      this['point' + item.id] = React.createRef();
    })
  }

  componentDidMount() {
    this.setHighestPointHeight();
  }

  setHighestPointHeight() {
    const {scalePoints} = this.props;

    let highestPointHeight = 0;

    scalePoints.forEach((item) => {
      const pointRef = this['point' + item.id];
      if (pointRef && pointRef.current) {
        if (pointRef.current.clientHeight > highestPointHeight) {
          highestPointHeight = pointRef.current.clientHeight;
        }
      }
    });

    this.setState({highestPointHeight})
  }

  render() {
    const {scalePoints} = this.props;

    if(scalePoints.length === 0){
      return null;
    }

    return <div className="w-100 position-relative color-default" style={{height: this.state.highestPointHeight}}>
      <ReactResizeDetector handleWidth handleHeight onResize={this.setHighestPointHeight} />
      {scalePoints.map((point, i)=> {
        const scalePointWidth = (100 / scalePoints.length);
        const styles = {
          textAlign: 'center',
          width: scalePointWidth + '%'
        };

        const isFirstScalePoint = i === 0;
        const isLastScalePoint = i + 1 === scalePoints.length;
        const isOneBeforeLastScalePoint = i === scalePoints.length - 2;

        if (isFirstScalePoint) {
          styles.left = 0;
          styles.textAlign = 'left'
        } else if (isLastScalePoint) {
          styles.right = 0;
          styles.textAlign = 'right';
          styles.width = (scalePointWidth / 2) + '%';
        } else if (isOneBeforeLastScalePoint) {
          styles.width = (scalePointWidth / 2) + '%';
          styles.left = ((i / (scalePoints.length - 1) * 100)) - (scalePointWidth / 4) + '%';
        } else {
          styles.left = ((i / (scalePoints.length - 1) * 100)) - (scalePointWidth / 2) + '%';
        }

        return <span key={point.id} style={styles} className="position-absolute" ref={this['point' + point.id]} dangerouslySetInnerHTML={{__html: point.content}}/>
      })}
    </div>
  }
}

ScalePoints.propTypes = {
  scalePoints: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired).isRequired,
};

export default ScalePoints;